var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardAdd"},[_c('div',{staticClass:"card-body text-center"},[_c('i',{staticClass:"fas fa-plus mb-2"}),_c('p',[_vm._v(_vm._s(_vm.$t('Home.CardAdd.add')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }